export default "__VITE_ASSET__D_F7BSlJ__"